import { errorReason } from '@gef-ui/authorization-v2/constants';
import { getLabelMessage } from '@gef-ui/localization/messages';
import identity from "ramda/es/identity";
import { addError, showErrorMultiple, showErrorSingle, showFullScreenError } from '../actions';
import { getTraceId } from '../utils';
const middleware = ({ errorDispatch, getUser, defaultOptions = {}, globalErrorManipulation: globalErrorManipulationDefault = (payload)=>payload })=>()=>(next)=>(action)=>{
                if (action.type === 'REPORT_ERROR') {
                    const payload = action.payload || {};
                    const meta = action.payload?.meta || {
                        errorReport: {}
                    };
                    const { options = {}, errorManipulation = identity, ...other } = meta.errorReport || {};
                    const { enabled = true, globalErrorManipulation = globalErrorManipulationDefault, showResolver = ()=>({}), ...otherOptions } = {
                        ...defaultOptions,
                        ...options
                    };
                    if (enabled && action.payload !== errorReason.invalidRefresh) {
                        const errorPayload = {
                            options,
                            meta: {
                                requestUuid: meta.requestUuid,
                                status: payload.status,
                                body: payload.parsedContent,
                                statusText: payload.statusText,
                                url: payload.requestParams?.url || payload.originalAction?.endpoint,
                                method: payload.requestParams?.method || payload.originalAction?.method,
                                requestBody: payload.requestParams?.body || payload.originalAction?.body,
                                headers: payload.responseHeaders,
                                _originalAction: payload._originalAction
                            },
                            traceId: getTraceId(payload.traceparent),
                            shortDescription: payload.message,
                            ...other
                        };
                        const errorData = {
                            heading: errorPayload.heading || getLabelMessage('errors:genericErrorHeading'),
                            user: getUser?.(),
                            ...errorManipulation(globalErrorManipulation(errorPayload))
                        };
                        const { showMultipleErrorsModal = false, showSingleErrorModal = false, showUnclosableErrorModal = false, showErrorFullScreen = false } = {
                            ...otherOptions,
                            ...showResolver(errorPayload, errorData)
                        };
                        errorData.unclosable = showUnclosableErrorModal;
                        if (showSingleErrorModal || showUnclosableErrorModal) {
                            errorDispatch(showErrorSingle(errorData));
                        } else if (showErrorFullScreen) {
                            errorDispatch(showFullScreenError(errorData));
                        } else {
                            errorDispatch(addError(errorData, {
                                clearPrevious: (errors)=>errors.filter((error)=>{
                                        const previousUuid = error?.meta?.requestUuid;
                                        if (error?.meta?.requestUuid) {
                                            return previousUuid !== meta.requestUuid;
                                        }
                                        return true;
                                    })
                            }));
                        }
                        if (showMultipleErrorsModal) {
                            errorDispatch(showErrorMultiple());
                        }
                    }
                } else {
                    next(action);
                }
            };
export default middleware;
